// @flow
import * as React from 'react';
import TrackingHistoryInfo from 'components/atoms/TrackingHistoryInfo';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';
import './VerticalStepProgressBar.scss';
import { Icon } from 'components/atoms/Icon';

type Props = {
  appointmentStatus: [],
  intl: IntlShape
};

class VerticalStepProgressBar extends React.Component<Props> {
  static block = 'vertical-step-progress-bar';
  render() {
    const { intl } = this.props;
    const ns = VerticalStepProgressBar.block;
    const appointmentStatusLen = this.props.appointmentStatus.length;
    const uuidv1 = require('uuid/v1');
    const itemsToRender = this.props.appointmentStatus.map(
      (appointment, index) => {
        const isInProgress = appointment.inProgress ? ' current' : '';
        const isCompleted = appointment.isCompleted ? ' done' : '';
        return (
          <li
            key={uuidv1()}
            className={`${ns}__step--item ` + isInProgress + isCompleted}
          >
            <div>
              {isCompleted && (
                <Icon
                  type="check"
                  className={`${ns}__icon completed`}
                  aria-hidden={true}
                />
              )}
              {isInProgress && (
                <Icon
                  type="check"
                  className={`${ns}__icon in-progress`}
                  aria-hidden={true}
                />
              )}
              {!isInProgress &&
                !isCompleted && (
                  <Icon
                    type="check"
                    className={`${ns}__icon`}
                    aria-hidden={true}
                  />
                )}
              <TrackingHistoryInfo
                state={appointment.status}
                date={appointment.date}
                time={appointment.time}
                lastState={index + 1 === appointmentStatusLen}
                inProgress={appointment.inProgress}
                isCompleted={
                  appointment.isCompleted && !appointment.hideCompletedLabel
                }
                isToday={appointment.isToday}
                intl={intl}
                current={appointment.current}
              />
            </div>
          </li>
        );
      }
    );

    return (
      <div className={ns}>
        <div className={`${ns}__wrapper`}>
          <ul className={`${ns}__step`}>{itemsToRender}</ul>
        </div>
      </div>
    );
  }
}

export default VerticalStepProgressBar;



// WEBPACK FOOTER //
// ./src/components/molecules/VerticalStepProgressBar/VerticalStepProgressBar.js